import { createContext } from 'react';
import type { LoginInput, SignUpInput } from '@auditwire/contracts';
import type { AuthStatus, AuthUser } from './model/types';

export interface AuthContextValue {
  user: AuthUser | null;
  status: AuthStatus;
  signIn: (input: LoginInput) => Promise<void>;
  signUp: (input: SignUpInput) => Promise<void>;
  signOut: () => Promise<void>;
  refreshProfile: () => Promise<void>;
}

/** Kept in its own module so `AuthProvider.tsx` only exports a component (react-refresh). */
export const AuthContext = createContext<AuthContextValue | null>(null);
